import { render } from "./EditArticleModal.vue?vue&type=template&id=732b326e&scoped=true"
import script from "./EditArticleModal.vue?vue&type=script&lang=js"
export * from "./EditArticleModal.vue?vue&type=script&lang=js"

import "./EditArticleModal.vue?vue&type=style&index=0&id=732b326e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732b326e"]])

export default __exports__